import type { ComponentProps } from 'react';

import { AdvancedMarker } from '@vis.gl/react-google-maps';

/**
 * Renders a pulsing, centered marker at the given position.
 *
 * @param mapUserPositionMarkerProps - All props supported by `AdvancedMarker`. `position` is required.
 *   - `position`: The geographic coordinates where the marker should be placed.
 */
export function MapUserPositionMarker(mapUserPositionMarkerProps: ComponentProps<typeof AdvancedMarker>) {
  const { position, ...props } = mapUserPositionMarkerProps;

  if (!position) return null;

  return (
    <AdvancedMarker position={position} zIndex={20} {...props}>
      <div className="relative opacity-85" style={{ transform: 'translate(-50%, -50%)' }}>
        <span className="bg-blue block size-2.5 rounded-full shadow ring-2 ring-white" />
        <span className="bg-blue/15 pointer-events-none absolute top-1/2 left-1/2 size-5 -translate-x-1/2 -translate-y-1/2 animate-ping rounded-full duration-700" />
      </div>
    </AdvancedMarker>
  );
}
